<template>
    <div id="orderSuccesComponent">
        <div class="orderSuccesComponent-inner">
            <div class="wz-row">
                <div class="main-content" v-if="order">
                    <div class="main-content-inner">
                        <h2>Order Success</h2>
                        <div class="customer-info">
                            <h3>Customer information</h3>
                            <p>Receiver: {{order.username}}</p>
                            <p>Phone: {{order.user_id}} </p>
                            <p>Delivery address: {{order.to_address}}</p>
                            <p>Notes for order: {{order.note || 'N/A'}}</p>
                        </div>
                        <div class="products-info">
                            <div class="products-info-header">
                                <h3>Product information</h3>
                                <button type="button" @click="isOpen = !isOpen">Detail <i class="fa fa-angle-down"></i></button>
                            </div>
                            <div class="products-info-toogle" v-show="isOpen">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Price</th>
                                            <th>Quantity</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(orderitem,key) in order.order_data_item">
                                            <td data-title="Name" align="left">

                                                <h5 class="text-bold">
                                                  <span v-if="orderitem.Parent_Id"> + </span>
                                                  {{orderitem.Item_Name}}</h5>
                                                <span class="text-small text-left">{{orderitem.Note}}</span>
                                            </td>
                                            <td data-title="Price">{{orderitem.Price | formatPrice}}</td>
                                            <td data-title="Quantity">{{orderitem.Quantity}}</td>
                                            <td data-title="Total"><span class="text-bold">{{(orderitem.Price * orderitem.Quantity) | formatPrice}}</span></td>
                                        </tr>
                                    </tbody>
                                 </table>
                              <table class="table overview">
                                <tr>
                                  <td class="text">TOTAL ({{ count }} items)</td>
                                  <td class="total">{{ order.amount | formatPrice }}</td>
                                </tr>
                                <tr v-if="discount">
                                  <td class="text">Discount </td>
                                  <td class="total">{{ discount | formatPrice }}</td>
                                </tr>
                                <tr v-if="order.ship_price_real">
                                  <td class="text">Delivery fee </td>
                                  <td class="total">{{ order.ship_price_real | formatPrice }}</td>
                                </tr>
                                <tr>
                                  <td class="text">TOTAL</td>
                                  <td class="total">{{ order.total_amount | formatPrice }}</td>
                                </tr>

                                <tr v-if="order.total_amount && order.total_amount>0">
                                  <td class="text">TOTAL (VAT 8%)</td>
                                  <td class="total">{{ order.total_amount * 1.08 | formatPrice }}</td>
                                </tr>

                              </table>
                             </div>
                        </div>
                        <div class="action">
                            <button v-on:click="gotoShop"><i class="fa fa-angle-left"></i> Continue shopping</button>
                            <div class="contact_help">
                                <p>Contact: <a v-bind:href=" `tel:${hotline}` ">{{hotline}}</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Order',
        props:['idorder'],
        data () {
            let order = false;
            let key = 'order'+this.idorder;
            console.log('Key: ',key);
            order = sessionStorage.getItem(key);
            return {
                count: 0,
                order: "",
                discount : 0,
                isOpen: false,
                hotline:this.$foodbookConfig.hotline,
            };

        },
        created(){

        },
        mounted() {
            this.$http.get(this.$foodbookConfig.wpapi + '/orderInfo',{
                params: {
                    foodbook_code: this.idorder
                }
            }).then(response => {
                if(response.data) {
                    this.order = response.data.data;
                    this.count = this.order.order_data_item.length;
                    this.getCount();
                    if(this.order) {
                        if(this.order.voucher_log) {
                            if(this.order.voucher_log.used_discount_amount) {
                                this.discount = this.order.voucher_log.used_discount_amount;
                            }
                        }
                    }
                    //console.log(this.order);
                }
            });
        },
        filters: {

        },
        methods: {
            gotoShop(){
                window.location.replace(this.$foodbookConfig.menupage);
            },
            getCount() {
                if(this.order.order_data_item.length > 0) {
                    let _count=0;
                    _.forEach(this.order.order_data_item,function (el,index,arr) {
                        console.log(el.Quantity);
                        if(el.Quantity >0) _count = _count + el.Quantity;
                    });
                    this.count = _count;
                }
            }
        }
    }
</script>
<style>
  table.overview td{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/Order.vue